import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';

import { TaskListAuthenModel } from './models';

const TaskListAuthen = ({ fields }) => {

  const layoutData = useMemo(() => new TaskListAuthenModel().getData(fields), [fields]);

  useEffect(() => {
    if (layoutData?.redirectUrl && typeof window !== 'undefined') {
      window.location.href = layoutData.redirectUrl;
    }
  }, [layoutData?.redirectUrl]);

  return 'Loading...';
};

TaskListAuthen.propTypes = {
  fields: PropTypes.object,
  isLogin: PropTypes.bool
};

export default TaskListAuthen;
